export default "__VITE_ASSET__BRp6FDO2__"